"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throttle = void 0;
/**
 * Throttles repeat calls to a given method
 *
 * @name throttle
 * @param {Function} callback Method to call back when throttle period expires
 * @param {Number} limit Milliseconds to throttle/delay callback by
 * @returns {Variable} Result of the callback method
 */
const throttle = (callback, limit) => {
  let lastCallback;
  let lastRan;
  return function () {
    for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
      rest[_key] = arguments[_key];
    }
    const now = Date.now();
    if (!lastRan) {
      callback(rest);
      lastRan = now;
    } else {
      clearTimeout(lastCallback);
      lastCallback = setTimeout(() => {
        if (now - lastRan >= limit) {
          callback(rest);
          lastRan = now;
        }
      }, limit - (now - lastRan));
    }
  };
};
exports.throttle = throttle;